import { render, staticRenderFns } from "./UiHelplineButton.vue?vue&type=template&id=366d9807"
import script from "./UiHelplineButton.vue?vue&type=script&lang=ts"
export * from "./UiHelplineButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports